import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  .headerGraph {
    display: grid;
    grid-template-columns: 220px 1fr 220px;
    align-items: center;
    margin-bottom: 12px;

    > h4:first-of-type {
      justify-self: start;
      margin: 0;
    }

    > h4:last-of-type {
      justify-self: center;
      text-align: center;
      margin: 0;
    }

    > div {
      justify-self: end;
    }
  }
`;

export const Filtros = styled.div`
  display: flex;
  gap: 20px; // Espaçamento para o botão de Buscar
  align-items: center; // Centralizar verticalmente o botão de Buscar
  justify-content: center; // Centralizar todo filtro
  > div {
    display: flex;
    gap: 10px; //Espaçamento entre filtros
    fieldset {
      min-width: 8rem; // Para a borda superior de político não ficar pequena
      padding: 0 10px; // Para os fields não ficarem colados na borda
      align-content: center; // Para centralizar as checkbox no centro verticalmente
      border: 1px solid ${props => props.theme.loadingTableColor}; // Para criar a borda
      border-radius: 5px; // Para fazer a curvatura na borda
      justify-items: center; // Para centralizar o switch de Políticos
      // Período
      &:first-of-type {
        z-index: 2; // Para o calendário ficar a frente do gráfico e do outro Datepicker
        > div {
          margin-left: 0; // Para não espaçar o segundo Datepicker
        }
      }
      legend {
        display: flex;
        align-items: center; // Para alinhar verticalmente o botão de ptoVenda
        font-size: 0.8rem; // Tamanho do texto da legenda
        color: ${props => props.theme.fontColor}; // Cor do texto da legenda
        opacity: 0.7; // Opacidade do texto da legenda
        padding: 0px 5px; // Para a borda não ficar colada ao texto
        button {
          height: 15px; // Forçando altura do botão de todos ptoVenda
        }
      }
    }
  }
`;

export const ChartContent = styled.div`
  height: calc(100vh - 290px);
  > p {
    margin-left: 20px;
  }
`;
